<template>
  <b-card class="mb-4 shadow" v-if="job.options">
    <JobOptions
      v-model="job"
      @input="$nextTick(change)"
      @done="$nextTick(saveChanges)"
    />

    <b-collapse v-model="changed">
      <b-button @click="saveChanges">Save Changes</b-button>
    </b-collapse>
  </b-card>
</template>

<script>
import JobOptions from '@/components/JobOptions.vue'

import * as bs from 'bootstrap-vue';
import Vue from 'vue';

[
    bs.CardPlugin,
].forEach(p=> Vue.use(p))

export default {
  props: ["job"],
  components:{JobOptions},
  data() {
    return {
      lastSave: null,
      lastName: null,
      changed: false
    };
  },
  created() {
    this.update();
  },
  computed: {},
  watch: {
    job() {
      this.update();
    }
  },
  methods: {
    change() {
      this.changed = (JSON.stringify(this.job.options) !== this.lastSave || this.job.name !== this.lastName) 
    },
    update() {
      if (!this.job) throw new Error("Missing job");
      this.job.options = JSON.parse(this.job.optionsJSON);
      if (!this.job.options) this.job.options = {};
      if (!this.job.options.quality) this.job.options.quality = "medium";
      this.lastSave = JSON.stringify(this.job.options);
      this.lastName = this.job.name;
      this.changed = false;

    },
    saveChanges() {
      let self = this, opts = this.job.options, name = this.job.name;
      this.$api.editJob(this.job.id, this.job.options, this.job.name)
      .then(() => {
            self.changed = false;
            self.lastSave = opts;
            self.lastName = name;
        });
    }
  }
};
</script>

<style>
</style>